// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Caml_splice_call from "../../../../../../node_modules/rescript/lib/es6/caml_splice_call.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.mjs";
import * as UrlUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.mjs";
import * as NetworkV2$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.mjs";
import * as Config$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as CookieUtils$PorterinFeature from "../../../containers/fare-estimate-v1/utils/browser/CookieUtils.mjs";
import * as CommonHelper$PorterinFeature from "../../core/helpers/CommonHelper.mjs";
import * as FareEstimateHelper$PorterinFeature from "../../core/helpers/FareEstimateHelper.mjs";
import * as FareEstimateFormStore$PorterinFeature from "../../core/constants/FareEstimateFormStore.mjs";
import * as FareEstimateResponseConfig$PorterinFeature from "./FareEstimateResponseConfig.mjs";
import * as FareEstimateHashResponseConfig$PorterinFeature from "./FareEstimateHashResponseConfig.mjs";

function encodeFareEstimateFormUri(form_info) {
  return [
            [
              "geo_region_id",
              form_info.geo_region
            ],
            [
              "from_address_landmark",
              form_info.pickup_address.landmark
            ],
            [
              "to_address_landmark",
              form_info.drop_address.landmark
            ],
            [
              "from_address_lat",
              form_info.pickup_address.location.lat.toString()
            ],
            [
              "from_address_long",
              form_info.pickup_address.location.lng.toString()
            ],
            [
              "to_address_lat",
              form_info.drop_address.location.lat.toString()
            ],
            [
              "to_address_long",
              form_info.drop_address.location.lng.toString()
            ],
            [
              "customer_name",
              form_info.name
            ],
            [
              "customer_mobile",
              form_info.mobile
            ],
            [
              "user_type",
              "/"
            ],
            [
              "brand",
              "porter"
            ],
            [
              "frequency",
              form_info.requirement
            ],
            [
              "service_category",
              form_info.service_category
            ]
          ].reduce((function (dict, param) {
                dict[param[0]] = window.encodeURIComponent(param[1]);
                return dict;
              }), {});
}

function encodeFareEstimateForm(form_info, service_category, is_desktop, source) {
  var params = [
    [
      "from_address_landmark",
      form_info.pickup_address.landmark
    ],
    [
      "to_address_landmark",
      form_info.drop_address.landmark
    ],
    [
      "from_address_lat",
      form_info.pickup_address.location.lat.toString()
    ],
    [
      "from_address_long",
      form_info.pickup_address.location.lng.toString()
    ],
    [
      "to_address_lat",
      form_info.drop_address.location.lat.toString()
    ],
    [
      "to_address_long",
      form_info.drop_address.location.lng.toString()
    ],
    [
      "customer_name",
      form_info.name
    ],
    [
      "customer_mobile",
      form_info.mobile
    ],
    [
      "user_type",
      "/"
    ],
    [
      "brand",
      "porter"
    ],
    [
      "frequency",
      form_info.requirement
    ],
    [
      "service_category",
      service_category
    ],
    [
      "is_device_mobile",
      is_desktop ? "false" : "true"
    ],
    [
      "source_url",
      window.location.href
    ]
  ];
  Caml_splice_call.spliceObjApply(params, "push", [FareEstimateHelper$PorterinFeature.getUtmKeyValues(source)]);
  return params.reduce((function (dict, param) {
                dict[param[0]] = window.encodeURIComponent(param[1]);
                return dict;
              }), {});
}

function fetchFareEstimateHash(form, re_id, country) {
  var payload = encodeFareEstimateFormUri(form);
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config$PorterinUtils.oms_url, "/fare_estimate_secure", payload);
  var json_encode = {};
  json_encode["re_id"] = re_id;
  var payloadString = JSON.stringify(json_encode);
  return Js_promise.then_((function (result) {
                return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                            return Curry._1(FareEstimateHashResponseConfig$PorterinFeature.FareEstimateResultHashApiResponseConverter.execute, result);
                          });
              }), NetworkV2$Catalyst.post(requestUrl, {
                  country: country,
                  language: "en"
                }, payloadString, undefined, undefined, undefined, undefined));
}

function fetchFareEstimate(form, service_category, is_desktop, source, re_token, country) {
  var params = encodeFareEstimateForm(form, service_category, is_desktop, source);
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config$PorterinUtils.oms_url, "/website/fare_estimate_validator_v2", params);
  var json_encode = {};
  json_encode["re_id"] = re_token;
  var payload = JSON.stringify(json_encode);
  return Js_promise.then_((function (result) {
                var data = Curry._1(FareEstimateResponseConfig$PorterinFeature.FareEstimateResultApiResponseConverter.execute, result);
                if (data !== undefined) {
                  return Caml_option.valFromOption(data);
                } else {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: {
                                address_error_type: undefined,
                                field_errors: undefined,
                                form_error: "Some error occurred. Please retry"
                              }
                            });
                }
              }), NetworkV2$Catalyst.post(requestUrl, {
                  country: country,
                  "Web-Tracking-Id": CookieUtils$PorterinFeature.getCookie("web_tracking_id"),
                  language: "en"
                }, payload, undefined, undefined, undefined, undefined));
}

function getFareEstimateHash(redirect_link, estimate_form, recaptcha_execute, recaptcha_context, country) {
  var val = recaptcha_execute.executeRecaptcha("homepage");
  if (val !== undefined) {
    return Js_promise.$$catch((function (error) {
                  Curry._1(recaptcha_context.setRecaptchaState, true);
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: {
                                TAG: /* FareEstimateHashError */0,
                                _0: FareEstimateFormStore$PorterinFeature.recaptcha_error_message_text
                              }
                            });
                }), Js_promise.then_((function (token) {
                      return CommonHelper$PorterinFeature.handleAPIRequestV2((function (param) {
                                    return fetchFareEstimateHash(estimate_form, token, country);
                                  }), (function (data) {
                                    return Promise.resolve({
                                                TAG: /* Ok */0,
                                                _0: redirect_link + "&fare_estimate_token=" + data
                                              });
                                  }), (function (error) {
                                    return Promise.resolve({
                                                TAG: /* Error */1,
                                                _0: {
                                                  TAG: /* FareEstimateHashError */0,
                                                  _0: FareEstimateFormStore$PorterinFeature.recaptcha_error_message_text
                                                }
                                              });
                                  }));
                    }), Caml_option.valFromOption(val)));
  } else {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: {
                  TAG: /* FareEstimateHashError */0,
                  _0: FareEstimateFormStore$PorterinFeature.recaptcha_error_message_text
                }
              });
  }
}

function getFareEstimate(estimate_form, service_category, is_desktop, source, recaptcha_execute, recaptcha_context, country) {
  var val = recaptcha_execute.executeRecaptcha("homepage");
  if (val !== undefined) {
    return Js_promise.$$catch((function (error) {
                  Curry._1(recaptcha_context.setRecaptchaState, true);
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: {
                                TAG: /* FareEstimateHashError */0,
                                _0: FareEstimateFormStore$PorterinFeature.recaptcha_error_message_text
                              }
                            });
                }), Js_promise.then_((function (token) {
                      return CommonHelper$PorterinFeature.handleAPIRequestV2((function (param) {
                                    return fetchFareEstimate(estimate_form, service_category, is_desktop, source, token, country);
                                  }), (function (data) {
                                    return Promise.resolve({
                                                TAG: /* Ok */0,
                                                _0: data
                                              });
                                  }), (function (error) {
                                    return Promise.resolve({
                                                TAG: /* Error */1,
                                                _0: {
                                                  TAG: /* FareEstimateUrlError */1,
                                                  _0: error
                                                }
                                              });
                                  }));
                    }), Caml_option.valFromOption(val)));
  } else {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: {
                  TAG: /* FareEstimateHashError */0,
                  _0: FareEstimateFormStore$PorterinFeature.recaptcha_error_message_text
                }
              });
  }
}

export {
  encodeFareEstimateFormUri ,
  encodeFareEstimateForm ,
  fetchFareEstimateHash ,
  fetchFareEstimate ,
  getFareEstimateHash ,
  getFareEstimate ,
}
/* NetworkV2-Catalyst Not a pure module */
